// Learning points for committing either O or X, separate from card mastery.
export const ENCOUNTER_JUDGMENT_POINTS = 4;
